import * as React from "react";
import { FullPageLoader } from "@swiggy-private/payment-ui";
import { RouteProps } from "@payment-client/interfaces/Router";

export function RedirectPage(_props: RouteProps): React.ReactElement {
    return <FullPageLoader />;
}
